<h4 class="font-semibold">{{ group().titleKey | transloco }}</h4>
@for (item of group().items; track item.labelKey) {
  <div class="flex items-center justify-between gap-4 text-sm">
    <span class="flex items-center gap-2">
      @if (item.favorable === true) {
        <i class="pi pi-check-circle text-green"></i>
      } @else if (item.favorable === false) {
        <i class="pi pi-exclamation-circle text-orange"></i>
      } @else {
        <i class="pi pi-circle text-muted-color"></i>
      }
      {{ item.labelKey | transloco }}
    </span>
    <span class="font-semibold">
      {{
        (item.value | rfiMetricValue) ??
          ('project.steps.providerResults.individual.notSpecified' | transloco)
      }}
    </span>
  </div>
}
